(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SDShearMatcher = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const left = text => /left[ -]?hand|\blefties\b|\blefty\b/i.test(text);
  const color = value => {
    const s = String(value || '').toLowerCase();
    if (/rose.?gold/.test(s)) return 'Rose gold';
    if (/black.*(?:gold|silver)|(?:gold|silver).*black/.test(s)) return /gold/.test(s) ? 'Gold & black' : 'Black & silver';
    if (/gunmetal|gun metal/.test(s)) return 'Gunmetal';
    for (const [pattern, label] of [[/rainbow/,'Rainbow'],[/purple/,'Purple'],[/pink/,'Pink'],[/light blue/,'Light blue'],[/blue/,'Blue'],[/red/,'Red'],[/black/,'Black'],[/gold/,'Gold'],[/silver|stainless steel/,'Silver']]) if (pattern.test(s)) return label;
    return '';
  };
  function kind(value) {
    const s = value.toLowerCase();
    if (/game.?changer/.test(s)) return 'gamechanger';
    if (/chunk/.test(s)) return 'chunker';
    if (/thinn|blend/.test(s)) return 'thinner';
    if (/curv/.test(s)) return 'curved';
    if (/straight/.test(s)) return 'straight';
    return '';
  }
  function classify(product) {
    const variants = product.variants || [];
    const configurations = variants.map(v => (v.selectedOptions || []).filter(o => !/size|length|colou?r|finish/i.test(o.name)).map(o => o.value).join(' '));
    const mixedHand = configurations.some(left) && configurations.some(c => !left(c));
    const defaultLeft = !mixedHand && left(product.title + ' ' + product.type);
    const result = [];
    variants.forEach((v, i) => {
      const config = configurations[i];
      if (/\bset\b|\b\d\s*(?:pc|piece)\b/i.test(config) || /shear sets|misprint|grooming tools/i.test(product.type)) return;
      const selected = v.selectedOptions || [];
      const sizeOption = selected.find(o => /size|length/i.test(o.name));
      const size = sizeOption ? parseFloat(sizeOption.value) : NaN;
      const colorOption = selected.find(o => /colou?r|finish/i.test(o.name));
      const baseKind = kind(product.type) || kind(product.title);
      const type = ['thinner','chunker','gamechanger'].includes(baseKind) ? baseKind : kind(config) || baseKind;
      if (!type || !v.available || !Number.isFinite(v.price)) return;
      result.push({id:String(v.id).split('/').pop(),hand:left(config)||defaultLeft?'left':'right',kind:type,size:Number.isFinite(size)?size:null,color:color(colorOption?.value),price:v.price,options:selected.map(o=>({name:o.name,value:o.value}))});
    });
    return result;
  }
  function matches(v, answers) {
    if (v.hand !== answers.hand || v.kind !== answers.kind || v.price > Number(answers.budget)) return false;
    if (answers.size === 'short' && !(v.size >= 5 && v.size <= 6.5)) return false;
    if (answers.size === 'medium' && !(v.size >= 7 && v.size <= 7.5)) return false;
    if (answers.size === 'long' && !(v.size >= 8 && v.size <= 10)) return false;
    return !answers.color || answers.color === 'any' || v.color === answers.color;
  }
  function score(v, answers) {
    const preferred = answers.coat==='small'?6.5:answers.coat==='large'?8:7.5;
    return (v.size === null ? 3 : Math.abs(v.size-preferred))*1000 + v.price/100;
  }
  function ajaxProduct(p) {
    return {title:p.title,type:p.type || '',variants:(p.variants || []).map(v=>({id:v.id,price:v.price,available:v.available,selectedOptions:(p.options || []).map((o,i)=>({name:typeof o==='string'?o:o.name,value:v.options?.[i] || v['option'+(i+1)] || ''}))}))};
  }
  return {color, classify, matches, score, ajaxProduct};
});